import {
  all,
  call,
  cancelled,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import SelfService from "../../services/SelfService";
import {
  userDetailsSuccess,
  userDetailsFail,
  learningProgramsSuccess,
  learningProgramsFail,
  compliancePassportSuccess,
  compliancePassportFail,
  assignedProgramSuccess,
  assignedProgramFail,
  markAsCompleteSuccess,
  markAsCompleteFail,
  learningStatsSuccess,
  learningStatsFail,
  learningStatusCountSuccess,
  learningStatusCountFail,
  changePasswordSuccess,
  changePasswordFail,
  notificationsSuccess,
  notificationsFail,
  learningMilestoneCountSummaryFail,
  learningMilestoneCountSummarySuccess,
  learningMilestoneItemSummaryFail,
  learningMilestoneItemSummarySuccess,
  learningMilestoneUsersFail,
  learningMilestoneUsersSuccess,
  learningObjectCountSummaryFail,
  learningObjectCountSummarySuccess,
  learningObjectItemSummaryFail,
  learningObjectItemSummarySuccess,
  learningObjectUsersFail,
  learningObjectUsersSuccess,
  learningProgramCountSummaryFail,
  learningProgramCountSummarySuccess,
  learningProgramItemSummaryFail,
  learningProgramItemSummarySuccess,
  learningProgramUsersFail,
  learningProgramUsersSuccess,
  learningObjectUserExcelFail,
  learningObjectUserExcelSuccess,
  learningMilestoneUserExcelFail,
  learningMilestoneUserExcelSuccess,
  learningProgramUserExcelFail,
  learningProgramUserExcelSuccess,
  updateDetailSuccess,
  updateDetailFail,
  fullProfileSuccess,
  fullProfileFail,
  updateAccountPreferencesSuccess,
  updateAccountPreferencesFail,
  updateNotificationReadSuccess,
  updateNotificationReadFail,
  setPasswordSuccess,
  setPasswordFail,
} from "../slices/selfSlice";

function* profile() {
  try {
    const ajax = yield call(SelfService.profile);
    if (ajax.status === 200) {
      yield put(userDetailsSuccess(ajax.data));
    } else {
      yield put(
        userDetailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      userDetailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningPrograms() {
  try {
    const ajax = yield call(SelfService.learningPrograms);
    if (ajax.status === 200) {
      yield put(learningProgramsSuccess(ajax.data));
    } else {
      yield put(
        learningProgramsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* compliancePassport() {
  try {
    const ajax = yield call(SelfService.compliancePassport);
    if (ajax.status === 200) {
      yield put(compliancePassportSuccess(ajax.data));
    } else {
      yield put(
        compliancePassportFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      compliancePassportFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* programDetails(data) {
  try {
    const ajax = yield call(SelfService.programDetails, data.payload);
    if (ajax.status === 200) {
      yield put(assignedProgramSuccess(ajax.data));
    } else {
      yield put(
        assignedProgramFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      assignedProgramFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* markAsCompleted(data) {
  try {
    const ajax = yield call(SelfService.markAsCompleted, data.payload);
    if (ajax.status === 200) {
      yield put(markAsCompleteSuccess(ajax.data));
    } else {
      yield put(
        markAsCompleteFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      markAsCompleteFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* changePassword(data) {
  try {
    const ajax = yield call(SelfService.changePassword, data.payload);
    if (ajax.status === 200) {
      yield put(changePasswordSuccess(ajax.data));
    } else {
      yield put(
        changePasswordFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      changePasswordFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* setPassword(data) {
  try {
    const ajax = yield call(SelfService.setPassword, data.payload);
    if (ajax.status === 200) {
      yield put(setPasswordSuccess(ajax.data));
    } else {
      yield put(
        setPasswordFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      setPasswordFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningStats(data) {
  try {
    const ajax = yield call(SelfService.learningStats, data.payload);
    if (ajax.status === 200) {
      yield put(learningStatsSuccess(ajax.data));
    } else {
      yield put(
        learningStatsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningStatsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningStatusCount(data) {
  try {
    const ajax = yield call(SelfService.learningStatusCount, data.payload);
    if (ajax.status === 200) {
      yield put(learningStatusCountSuccess(ajax.data));
    } else {
      yield put(
        learningStatusCountFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningStatusCountFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* notifications(data) {
  try {
    const ajax = yield call(SelfService.notifications, data.payload);
    if (ajax.status === 200) {
      yield put(notificationsSuccess(ajax.data));
    } else {
      yield put(
        notificationsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      notificationsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectCountSummary(data) {
  try {
    const ajax = yield call(
      SelfService.learningObjectCountSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningObjectCountSummarySuccess(ajax.data));
    } else {
      yield put(
        learningObjectCountSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectCountSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectsSummary(data) {
  try {
    const ajax = yield call(SelfService.learningObjectsSummary, data.payload);
    if (ajax.status === 200) {
      yield put(learningObjectItemSummarySuccess(ajax.data));
    } else {
      yield put(
        learningObjectItemSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectItemSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectsUsers(data) {
  try {
    const ajax = yield call(SelfService.learningObjectsUsers, data.payload);
    if (ajax.status === 200) {
      yield put(learningObjectUsersSuccess(ajax.data));
    } else {
      yield put(
        learningObjectUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramCountSummary(data) {
  try {
    const ajax = yield call(
      SelfService.learningProgramCountSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningProgramCountSummarySuccess(ajax.data));
    } else {
      yield put(
        learningProgramCountSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramCountSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramsSummary(data) {
  try {
    const ajax = yield call(SelfService.learningProgramsSummary, data.payload);
    if (ajax.status === 200) {
      yield put(learningProgramItemSummarySuccess(ajax.data));
    } else {
      yield put(
        learningProgramItemSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramItemSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramsUsers(data) {
  try {
    const ajax = yield call(SelfService.learningProgramsUsers, data.payload);
    if (ajax.status === 200) {
      yield put(learningProgramUsersSuccess(ajax.data));
    } else {
      yield put(
        learningProgramUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestoneCountSummary(data) {
  try {
    const ajax = yield call(
      SelfService.learningMilestoneCountSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningMilestoneCountSummarySuccess(ajax.data));
    } else {
      yield put(
        learningMilestoneCountSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneCountSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestonesSummary(data) {
  try {
    const ajax = yield call(
      SelfService.learningMilestonesSummary,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(learningMilestoneItemSummarySuccess(ajax.data));
    } else {
      yield put(
        learningMilestoneItemSummaryFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneItemSummaryFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestonesUsers(data) {
  try {
    const ajax = yield call(SelfService.learningMilestonesUsers, data.payload);
    if (ajax.status === 200) {
      yield put(learningMilestoneUsersSuccess(ajax.data));
    } else {
      yield put(
        learningMilestoneUsersFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneUsersFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningObjectsUsersExcel(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(
      SelfService.learningObjectsUsersExcel,
      data.payload
    );
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `learning_object_report.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(learningObjectUserExcelSuccess());
    } else {
      yield put(
        learningObjectUserExcelFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningObjectUserExcelFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningMilestonesUsersExcel(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(
      SelfService.learningMilestonesUsersExcel,
      data.payload
    );
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `learning_milestone_report.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(learningMilestoneUserExcelSuccess());
    } else {
      yield put(
        learningMilestoneUserExcelFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningMilestoneUserExcelFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* learningProgramsUsersExcel(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(
      SelfService.learningProgramsUsersExcel,
      data.payload
    );
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `learning_program_report.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(learningProgramUserExcelSuccess());
    } else {
      yield put(
        learningProgramUserExcelFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramUserExcelFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* fullProfile(data) {
  try {
    const ajax = yield call(SelfService.fullProfile, data.payload);
    if (ajax.status === 200) {
      yield put(fullProfileSuccess(ajax.data));
    } else {
      yield put(
        fullProfileFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      fullProfileFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* update(data) {
  try {
    const ajax = yield call(SelfService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* updateAccountPreferences(data) {
  try {
    const ajax = yield call(SelfService.updateAccountPreferences, data.payload);
    if (ajax.status === 200) {
      yield put(updateAccountPreferencesSuccess(ajax.data));
    } else {
      yield put(
        updateAccountPreferencesFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateAccountPreferencesFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* markNotificationAsRead(data) {
  try {
    const ajax = yield call(SelfService.markNotificationAsRead, data.payload);
    if (ajax.status === 200) {
      yield put(updateNotificationReadSuccess(ajax.data));
    } else {
      yield put(
        updateNotificationReadFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateNotificationReadFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* selfSaga() {
  yield all([
    takeLatest("self/userDetailsRequest", profile),
    takeEvery("self/learningProgramsRequest", learningPrograms),
    takeLatest("self/compliancePassportRequest", compliancePassport),
    takeLatest("self/assignedProgramRequest", programDetails),
    takeLatest("self/markAsCompleteRequest", markAsCompleted),
    takeLatest("self/learningStatsRequest", learningStats),
    takeLatest("self/learningStatusCountRequest", learningStatusCount),
    takeLatest("self/changePasswordRequest", changePassword),
    takeLatest("self/setPasswordRequest", setPassword),
    takeLatest("self/notificationsRequest", notifications),
    takeLatest("self/updateDetailRequest", update),
    takeLatest("self/fullProfileRequest", fullProfile),
    takeLatest(
      "self/updateAccountPreferencesRequest",
      updateAccountPreferences
    ),
    takeLatest(
      "self/learningObjectCountSummaryRequest",
      learningObjectCountSummary
    ),
    takeLatest("self/learningObjectItemSummaryRequest", learningObjectsSummary),
    takeLatest("self/learningObjectUsersRequest", learningObjectsUsers),
    takeLatest(
      "self/learningProgramCountSummaryRequest",
      learningProgramCountSummary
    ),
    takeLatest(
      "self/learningProgramItemSummaryRequest",
      learningProgramsSummary
    ),
    takeLatest("self/learningProgramUsersRequest", learningProgramsUsers),
    takeLatest(
      "self/learningMilestoneCountSummaryRequest",
      learningMilestoneCountSummary
    ),
    takeLatest(
      "self/learningMilestoneItemSummaryRequest",
      learningMilestonesSummary
    ),
    takeLatest("self/learningMilestoneUsersRequest", learningMilestonesUsers),
    takeLatest(
      "self/learningObjectUserExcelRequest",
      learningObjectsUsersExcel
    ),
    takeLatest(
      "self/learningMilestoneUserExcelRequest",
      learningMilestonesUsersExcel
    ),
    takeLatest(
      "self/learningProgramUserExcelRequest",
      learningProgramsUsersExcel
    ),
    takeLatest("self/updateNotificationReadRequest", markNotificationAsRead),
  ]);
}
